import React from 'react';
import { GiftIcon } from 'lucide-react';
import { formatPrice } from '../data/config';
type BonusCardProps = {
  number: string;
  title: string;
  price: number;
  points: string[];
  finalLine: string;
  showReferencePrice: boolean;
};
export function BonusCard({
  number,
  title,
  price,
  points,
  finalLine,
  showReferencePrice
}: BonusCardProps) {
  const [lead, ...rest] = points;
  return <article className="rounded-md border-l-[5px] border-gold bg-white px-3.5 py-3 text-left md:px-4" data-id="element-10" data-mp="20ezkprd0tzm9">
      <h3 className="flex items-start gap-2 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[15px]" data-id="element-11" data-mp="25crcmldo1lqg">
        <GiftIcon className="mt-px h-4 w-4 shrink-0 text-goldDark" strokeWidth={2.5} aria-hidden data-id="element-12" data-mp="29dl39mihten1" />
        <span data-id="element-13" data-mp="2e7ffy5zoktcm">
          Bonus {number} — {title}
        </span>
      </h3>
      <p className="mt-1 font-heading text-[12px] font-bold leading-snug text-brand md:text-[13px]" data-id="element-14" data-mp="1hmx24agtk99d">{lead}</p>
      <p className="mt-0.5 flex flex-wrap items-center gap-2 font-heading text-[11px] font-extrabold uppercase md:text-[12px]" data-id="element-15" data-mp="1lo8sii7ioyim">
        {showReferencePrice && <s className="font-semibold text-ink/60" data-id="element-16" data-mp="1s31q0ry6l9s3">{formatPrice(price)}</s>}
        <span className="text-check" data-id="element-17" data-mp="1s54rc84sapc4">Free with your purchase</span>
      </p>
      <div className="mt-1 space-y-1 text-[14px] leading-[1.35] text-ink md:text-[15px]" data-id="element-18" data-mp="1nb0h9g08216t">
        {rest.map(p => <p key={p} data-id="element-19" data-mp="1ib4f7mb34jtw">{p}</p>)}
      </div>
      <p className="mt-1.5 font-heading text-[12px] font-extrabold uppercase leading-tight text-goldDark md:text-[13px]" data-id="element-20" data-mp="1dee0b2b0nua2">
        {finalLine}
      </p>
    </article>;
}